module.exports = {
    programmaticTitle:'Programmatic MKT',
    dashboard: 'Dashboard',
    report: 'Report',
    setting: 'Setting',
    fixedDimension: 'Fixed Dimension',
    creativesTemplate: 'Creatives Template',
    bundleTemplate: 'Bundles Template',
    bundle: 'Bundle',
    selectAdv: 'Please select Adv',
    uploadDate: 'Upload Date',
    records: 'Records',
    activeTime: 'Active Time',
    package: 'Package',
    selectPackage: 'Please select package',
    selectPid: 'Please select pid',
    day: 'Day',
    affiliate: 'Affiliate',
    creativeID: 'Creative ID',
    creativeSize: 'Creative Size',
    vsLastPeriod: 'vs last period',
    top5Bundles: 'Top 5 Bundles',
    rankingByConversion: 'Ranking by conversion',
    selectDateRange: 'please select data range',
    uploadExcelFile: 'Please upload excel file',
    addPid: 'Please add PID',
    addPkg: 'Please add PKG',
    reUpload: 're-upload',
    trends: 'Trends',
    underConstruction: 'under construction',
    affId: 'Aff Id',
    subAffId: 'Shadow Aff Id',
    confirmDelete: 'Are you sure delete this item?',
    inputAffId: 'Please input aff id',
    inputSubAffId: 'Please input shadow aff id',
    affIdHave: 'Aff id existed',
    affIdNumValidate: 'Aff id is Number',
    shadowAffIdNumValidate: 'Shadow Aff id is Number',
    affIdNoMoreSix: 'Aff id no more than 6',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/programmatic/en.js